import {
    BUSINESS_EVENTBRITE_CATEGORY,
    EVENTBRITE_CATEGORY_IMAGES,
    EVENTBRITE_CATEGORY_MAPPING,
    EVENTBRITE_CATEGORY_TO_REFINEMENT,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    HEALTH_EVENTBRITE_CATEGORY,
    HOBBIES_EVENTBRITE_CATEGORY,
    MUSIC_EVENTBRITE_CATEGORY,
    PERFORMING_EVENTBRITE_CATEGORY,
    SEASONAL_EVENTBRITE_CATEGORY,
    SPORTS_EVENTBRITE_CATEGORY,
} from '@eventbrite/categories';
import {
    CategoryScrollTemplate,
    HorizontalSlider,
    HorizontalSliderCard,
} from '@eventbrite/category-scroll';
import { GenericLazyString } from '@eventbrite/i18n';
import { logEvent } from '@eventbrite/statsig';
import React from 'react';
import holiday_halloween from '../../../../static/images/search/holiday_halloween.webp';
import { STATSIG_HOME_CLICK_TRENDING_CATEGORY } from '../../constants/analytics';
import './ImageCategoryBrowse.scss';

export const ImageCategoryBrowse = (props: { showSeasonalEvent?: boolean }) => {
    interface Category {
        key: string;
        name: string | GenericLazyString;
        imageUrl: any;
    }

    const CATEGORY_KEYS = [
        MUSIC_EVENTBRITE_CATEGORY,
        PERFORMING_EVENTBRITE_CATEGORY,
        SEASONAL_EVENTBRITE_CATEGORY,
        HEALTH_EVENTBRITE_CATEGORY,
        HOBBIES_EVENTBRITE_CATEGORY,
        BUSINESS_EVENTBRITE_CATEGORY,
        FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
        SPORTS_EVENTBRITE_CATEGORY,
    ];

    const CATEGORIES: Category[] = CATEGORY_KEYS.map((category) => {
        const showSeasonalEventImage =
            props.showSeasonalEvent && category == SEASONAL_EVENTBRITE_CATEGORY;
        return {
            key: EVENTBRITE_CATEGORY_TO_REFINEMENT[category],
            name: EVENTBRITE_CATEGORY_MAPPING[category],
            imageUrl: showSeasonalEventImage
                ? holiday_halloween
                : EVENTBRITE_CATEGORY_IMAGES[category],
        };
    });

    return (
        <CategoryScrollTemplate wrappingClasses="sectionPadding">
            <HorizontalSlider cards={CATEGORIES}>
                {(category) => {
                    return (
                        <a
                            data-heap-id="homepage-category-tiles"
                            key={category?.key}
                            href={`/b/local/${category?.key}`}
                            onClick={() => {
                                logEvent(STATSIG_HOME_CLICK_TRENDING_CATEGORY);
                            }}
                        >
                            <HorizontalSliderCard
                                title={category?.name || ''}
                                imageUrl={category?.imageUrl}
                                imageLoading={'lazy'}
                            />
                        </a>
                    );
                }}
            </HorizontalSlider>
        </CategoryScrollTemplate>
    );
};
